export default {
  // ? ===================
  // ? =====  Layout  ====
  // ? ===================

  navigation: {
    '.container': {
      backgroundColor: 'none',
      // borderBottom: '2px solid',
      // borderColor: 'secondary',
      padding: ['0.5rem', '0.5rem', '1rem', '1rem'],
      zIndex: '1001'
    },

    '.smallNavMenu > div': {
      border: 'none',
      '.navItem': {
        color: 'light',
        a: {
          fontSize: ['1rem', '1rem', '1rem', '1rem']
        }
      }
    },

    '.navItemDropdownMenu': {
      //   display: 'none'
      minWidth: '180px'
    },

    '.navItem': {
      color: 'light',
      margin: '0rem',
      padding: ['0.75rem', '0.75rem', '1rem'],
      width: '100%',
      flexGrow: '1',
      ':hover': {
        color: 'inherit'
      }
    },
    '.hamburger > div': {
      backgroundColor: 'white'
    },

    '.navMenuLogo': {
      position: 'static',
      width: ['100%', '', '100%'],
      padding: ['0.5rem', '', '2rem'],
      // borderBottom: '1px solid',
      // borderColor: 'secondary',
      margin: '0rem',
      img: {
        maxHeight: ['55px', '', '100px', '']
        // filter: 'brightness(0) invert(1)'
      }
    },
    '.navMenuOpen': {
      backgroundColor: 'black',
      width: ['100%', '', '100%'],
      justifyContent: ['center', 'center', 'center'],
      padding: '0rem',
      borderLeft: '10px solid',
      borderColor: 'secondary',
      '.seperatorLine': {
        width: '100%',
        maxWidth: 'unset',
        borderColor: 'secondary',
        margin: '1rem 0rem 0rem',
        display: 'none'
      },
      '.navItem': {
        padding: ['0.75rem', '0.75rem', '1rem', '0.75rem', '0.75rem', '1rem'],
        flexGrow: 'unset',
        a: {
          fontSize: ['1rem', '1.25rem', '1.5rem', '1.75rem']
        }
      }
    },
    '.navBlockOpen': {
      position: 'fixed',
      left: '0rem',
      top: '0rem',
      width: '100%',
      height: '100vh',
      backdropFilter: 'blur(2px)',
      backgroundColor: 'rgb(30 24 6 / 70%)'
    },
    '.phoneSocialContainer': {
      width: '100%',
      maxWidth: 'unset',
      marginTop: '1rem',
      display: 'flex',
      flexDirection: 'row',
      '> .socialIconsContainer, > .phoneContainer': {
        '.smallNavHeading': {
          fontSize: ['1.1rem', '1.5rem']
        },
        margin: '0rem',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'fit-content',
        color: 'light',
        border: 'none',
        // width: '100%',
        fontSize: '1rem',
        maxWidth: 'unset',
        padding: ['0.5rem', '', '2rem'],
        svg: {
          path: {
            fill: 'light'
          }
        }
      }
    },

    '.containerScrolled': {
      backgroundColor: 'black',
      borderBottom: '2px solid',
      borderColor: 'secondary',
      zIndex: '1001',
      '.hamburger > div': {
        backgroundColor: '#c6a34d'
      }
    },
    '.logo': {
      img: {
        opacity: '1',
        maxHeight: ['65px', '65px']
        // filter: 'brightness(0) invert(1)'
      }
    },
    '.logoScrolled': {
      img: {
        opacity: '1',
        maxHeight: ['55px', '55px']
        // filter: 'brightness(0) invert(1)'
      }
    }
  },

  footer: {
    borderTop: '1px solid lightgrey',
    backgroundColor: 'black',
    '.socialContainer, .contactDetails-container': {
      svg: {
        path: {
          fill: 'grey'
        }
      }
    },

    '.logo': {
      //   filter: 'brightness(0) invert(1)',
      marginBottom: '1rem',
      maxHeight: '100px'
    },

    '.sectionHeading': {
      color: 'secondary',
      fontWeight: '500',
      borderColor: 'secondary'
    },

    '.poweredBy .gonationLogo': {
      filter: 'brightness(0) invert(0.6)'
    },
    '.copyright': {
      backgroundColor: 'transparent',
      color: 'black'
    },
    '.multiButtonContainer': {
      justifyContent: ['center', '', '', 'flex-start']
    }
  },

  ctaWidget: {
    display: 'none',
    a: {
      backgroundColor: 'secondary'
    }
  },

  // ? ====================
  // ? ==== Reuseables ====
  // ? ====================

  title: {
    width: 'fit-content',
    borderBottom: '2px solid',
    borderColor: 'secondary',
    display: 'flex',
    flexDirection: 'column',
    fontSize: '2.5rem',
    order: '2',
    color: 'primary',
    fontWeight: '500',
    whiteSpace: 'pre-wrap',
    marginBottom: '1.5rem'
  },

  subtitle: {
    color: 'secondary',
    fontWeight: 'bold',
    textTransform: 'initial',
    order: '1',
    fontFamily: 'body',
    fontSize: '1.5rem',
    textTransform: 'uppercase'
  },

  text: {
    order: '3'
  },

  sideBySide1: {
    margin: '1rem 0rem',
    '.content': {
      width: ['', '', '50%'],

      padding: ['2rem', '', '', '1.5rem 3.5rem', '2.5rem 4.5rem'],
      '.title': {
        variant: 'customVariants.title'
      },
      '.subtitle': {
        variant: 'customVariants.subtitle'
      },
      '.text': {
        variant: 'customVariants.text'
      },
      a: {
        order: '4'
      }
    },
    '.lazyload-wrapper': {
      width: ['', '', '50%'],
      img: {
        height: '75vh',
        borderLeft: '15px solid',
        borderColor: 'secondary'
      }
    },
    '.ctaButton': {
      variant: 'buttons.primary'
    }
  },

  sideBySide2: {
    variant: 'customVariants.sideBySide1',
    '.content': {
      order: '2',
      width: ['', '', '50%'],
      padding: ['2rem', '', '', '1.5rem 3.5rem', '2.5rem 4.5rem'],
      '.title': {
        variant: 'customVariants.title'
      },
      '.subtitle': {
        variant: 'customVariants.subtitle'
      },
      '.text': {
        variant: 'customVariants.text'
      },
      a: {
        order: '4'
      }
    },
    '.lazyload-wrapper': {
      width: ['', '', '50%'],
      img: {
        height: '75vh',

        borderRight: '15px solid',
        borderColor: 'secondary'
      }
    }
  },

  // ? ====================
  // ? ====  Homepage  ====
  // ? ====================

  homepageHero: {
    // '.section': {
    //   border: 'none',
    //   width: ['100%', '', '65%'],
    //   maxWidth: 'unset',
    //   margin: '0rem',
    //   height: 'auto',
    // },
    '.hero_content_container': {
      borderColor: 'secondary',
      height: ['', '', '75%']
    },
    '.title': {
      variant: 'customVariants.title',
      fontFamily: 'display',
      order: 'unset',
      color: ['', '', 'white'],
      fontSize: ['2.5rem', '', '5rem', '6rem'],
      textAlign: ['', '', 'center']
    },
    '.subtitle': {
      variant: 'customVariants.subtitle',
      order: 'unset',
      color: ['', '', 'secondary'],
      fontSize: ['1.25rem', '', '1.5rem', '1.75rem'],
      textShadow: ['', '', '2px 2px 10px black']
    },
    '.text': {
      color: ['', '', 'white']
    },
    '.ctaButton': {
      // variant: 'buttons.primary',
      color: 'white'
    },
    '.imageContainer': {
      height: 'auto',
      maxHeight: 'unset',
      display: 'block'
    }
  },
  homepageHeroShout: {
    '.title': {
      variant: 'customVariants.title',
      fontFamily: 'display',
      order: 'unset',
      fontSize: '1.75rem',
      color: ['', '', 'white']
    },
    marginTop: '2rem',
    borderColor: 'primary'
  },

  homepageShout: {
    maxHeight: ['', '', '50vh'],
    '.content': {
      padding: ['1rem', '', '', '4rem', '5rem'],
      alignItems: 'flex-start',
      textAlign: 'left'
    },
    '.title': {
      variant: 'customVariants.title',
      textAlign: 'left',
      margin: '1rem 0rem',
      // display: 'none',
      fontWeight: 'normal',
      border: 'none',
      // borderBottom: '2px solid',
      // borderColor: 'secondary',
      width: 'fit-content',
      fontSize: '0rem',
      color: 'background',
      '::before': {
        variant: 'customVariants.title',
        content: "'Recent News'" // ! bad coding but could't be bothered to shadow
      }
    },
    '.subtitle': {
      variant: 'customVariants.subtitle',
      textAlign: 'left',
      margin: '1rem 0rem'
    },
    '.text': {
      variant: 'customVariants.text',
      textAlign: 'left',
      margin: '1rem 0rem 2rem',
      maxWidth: 'unset'
    },
    '.date': {
      textAlign: 'left',
      margin: '1rem 0rem',
      color: '#357548',
      order: '2'
    },
    '.shoutCTABtns': {
      order: '5',
      '.shoutCTA': {
        variant: 'buttons.primary',
        padding: '1rem',
        fontSize: '1rem'
      }
    }
  },

  homepageAbout: {
    variant: 'customVariants.sideBySide1'
  },

  homepageMenu: {
    variant: 'customVariants.sideBySide2'
  },

  homepageGallery: {
    variant: 'customVariants.sideBySide1'
  },

  homepageEvents: {
    variant: 'customVariants.sideBySide2'
  },

  homepageHours: {
    variant: 'customVariants.sideBySide1'
  },

  // homepageSlider: {
  //   padding: '0rem',
  //   '.slick-dots': {
  //     display: 'none !important',
  //   },
  // },
  homepageTestimonials: {
    padding: ['2rem 1rem', '', '4rem 1rem'],
    maxWidth: 'unset',
    '.menuSectionTitle': {
      variant: 'customVariants.title',
      border: 'none',
      textAlign: 'center',
      margin: '0 auto 1rem'
    },

    '.menuSectionDescription': {
      variant: 'customVariants.text',
      fontSize: '1rem'
    },

    '.menuItemNameContainer': {
      variant: 'customVariants.subtitle',
      order: '4',
      margin: '1rem auto 0rem',
      textAlign: 'center'
    },

    '.menuItemName': {
      fontSize: ['1rem', '1rem', '1rem', '1rem']
    },

    '.menuItemDescription': {
      variant: 'customVariants.text',
      color: 'primary',
      fontSize: '1rem',
      textAlign: 'center',
      lineHeight: '1.5',
      width: '100%',
      padding: ['0rem', '', '0rem 1rem'],
      margin: '0 auto 1rem'
    },

    '.slick-slider': {
      maxWidth: '767px',
      margin: '0 auto'
    }
  },

  // ? ========================
  // ? =====  About page  =====
  // ? ========================

  aboutSection: {
    padding: ['3rem 1rem', '', '6rem 1rem', '7rem 1rem'],
    '.title': {
      fontSize: '2.5rem',
      color: 'primary',
      fontWeight: '500',
      whiteSpace: 'pre-wrap',
      borderBottom: '2px solid',
      borderColor: 'secondary'
    }
  },

  // ? ========================
  // ? =====  Menu page  =====
  // ? ========================

  menu: {
    border: 'solid 1px black',
    padding: ['1rem', '1rem'],
    margin: ['1rem 0.5rem', '', '', '', '1rem auto 3rem'],
    width: ['calc(100% - 1rem)'],
    backgroundColor: 'white',
    '.menuContainer': {
      paddingBottom: '1rem'
    },
    '.tabsRow': {
      padding: '0rem 0rem 1rem',
      marginBottom: '2rem',
      borderBottom: 'solid 2px',
      borderColor: 'secondary'
    },
    '#menuTab': {
      variant: 'buttons.primary',
      padding: '0.5rem 1.5rem',
      flexGrow: '1',
      width: 'fit-content',
      flexGrow: '1',
      display: 'flex',
      maxWidth: 'unset',
      minWidth: 'unset',
      textAlign: 'center',
      justifyContent: 'center',
      ':hover': {
        backgroundColor: 'primary'
      }
    },
    '.menuItemInnerContainer, .menuItemContentContainer': {
      margin: '0rem'
    },
    '.menuSectionTitle': {
      textTransform: 'uppercase',
      color: 'primary',
      borderBottom: 'solid 2px',
      borderColor: 'primary',
      margin: ['1rem', '', '1rem 1.5rem'],
      paddingBottom: '1rem',
      textAlign: 'center',
      fontSize: ['1.5rem', '', '2rem']
    },

    '.menuItemName': {
      color: 'black',
      fontFamily: 'heading'
    },

    '.menuSectionDescription': {
      fontSize: '1.1rem',
      textAlign: 'center',
      color: 'secondary',
      margin: ['1rem', '', '1rem 1.5rem']
    },
    '.menuItemDescription': {
      color: 'secondary'
    },
    '.menuPriceContainer': {
      fontFamily: 'heading'
      // display: 'none',
    },
    '.variantsContainer': {
      // display: 'none',
    },
    '.variantContainer': {
      flexGrow: '1',
      justifyContent: 'space-between'
    }
  },

  // ? ========================
  // ? ====  Gallery page  ====
  // ? ========================

  gallery: {
    '.albumsContainer': {
      // display: 'none',
    },
    '.albumTitle': {
      variant: 'buttons.primary',
      backgroundColor: 'transparent',
      color: 'black'
    },
    '.albumName': {
      color: 'secondary'
    },
    '.albumImage': {
      border: 'solid 2px',
      borderColor: 'primary'
    }
  },

  // ? ========================
  // ? ====  Events page  ====
  // ? ========================

  events: {
    '.no-events-container': {
      padding: '3rem 1rem',
      img: {
        // filter: 'brightness() invert(1)',
      }
    },
    '.eventItemImage': {
      minHeight: 'unset',
      maxHeight: 'unset',
      height: '100%'
    },
    '.eventDays, .eventDate': {
      color: 'black'
    }
  },

  // ? ========================
  // ? ====  Contact page  ====
  // ? ========================

  contactForm: {
    padding: '4rem 1rem',
    order: '4',
    border: '40px solid',
    borderColor: 'primary',

    '.title': {
      display: 'flex',
      flexDirection: 'column',
      fontSize: '2.5rem',
      color: 'primary',
      fontWeight: '500',
      whiteSpace: 'pre-wrap',
      borderBottom: '2px solid',
      borderColor: 'primary',
      marginBottom: '2rem'
    },
    '.subtitle': {
      textTransform: 'initial',
      fontSize: '1rem',
      opacity: '0.8',
      marginBottom: '4rem'
    },
    form: {
      input: {
        border: 'none',
        borderRadius: '0px',
        borderBottom: '1px solid',
        borderColor: 'secondary'
      },

      textarea: {
        border: 'none',
        borderRadius: '0px',
        borderBottom: '1px solid',
        borderColor: 'secondary'
      },
      '.submitBtn': {
        variant: 'buttons.primary',
        // borderRadius: '0px',
        textAlign: 'center',
        justifyContent: 'center'
      }
    }
  },

  locationMap: {
    order: '2',
    backgroundColor: '#fff7ed',
    borderLeft: '15px solid',
    borderColor: 'secondary',
    // color: 'white',
    h3: {
      textTransform: 'uppercase',
      fontSize: '2rem',
      borderBottom: '2px solid',
      borderColor: 'white'
    },

    '.dayofWeekText': {
      margin: '0 auto 0 0'
    }
  },

  // ? ========================
  // ? ====  Events Menu  ====
  // ? ========================

  eventsLeft: {
    variant: 'customVariants.sideBySide1'
  },
  eventsRight: {
    variant: 'customVariants.sideBySide2'
  },

  // ? ========================
  // ? ====  Press Menu  ====
  // ? ========================

  pressMenu: {},

  pressPage: {},

  // ? ========================
  // ? ====  Team Menu  ====
  // ? ========================

  teamMenu: {},

  teamPage: {},

  // ? ========================
  // ? ====  blog Menu  ====
  // ? ========================

  blogMenu: {},

  blogPage: {}
}
